module.exports = __webpack_public_path__ + "static/media/5.93592768.jpg";